import { useLabel } from '@react-aria/label'
import { SelectProps } from './Types'
import Styles from './Select.module.scss'
import { Select as BaseSelect } from 'components/Select/Select'
import { mergeProps } from '@react-aria/utils'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ForwardedRef, forwardRef } from 'react'
import cx from 'classnames'
import { Node } from 'components/Select/Types'

function Select(
  { renderSelectValue: baseRenderSelectValue, className, ...props }: SelectProps<object>,
  fRef: ForwardedRef<HTMLButtonElement>,
) {
  const { labelProps, fieldProps } = useLabel(props)
  const renderSelectValue = (selectedItem: Node) =>
    selectedItem ? (
      baseRenderSelectValue?.(selectedItem) || selectedItem.rendered
    ) : (
      <span className={Styles.placeholder}>{props.placeholder}</span>
    )
  return (
    <div className={cx(Styles.field, className, { [Styles.invalid]: props.isInvalid })}>
      {props.label && (
        <label className={Styles.label} {...labelProps}>
          <Heading level={5}>
            {props.label}
            {props.isRequired && (
              <>
                &nbsp;<span className={Styles.required}>*</span>
              </>
            )}
          </Heading>
        </label>
      )}
      <BaseSelect {...mergeProps(props, fieldProps)} ref={fRef} renderSelectValue={renderSelectValue}>
        {props.children}
      </BaseSelect>
    </div>
  )
}

const _Select = forwardRef(Select)
export { _Select as Select }
